import { filter, map, sumBy } from 'lodash';

import { formatMessage } from '@/utils/i18n';
import { RowType, TaxAnalysisTableKeys } from '../../types';

export const getTotalRow = (rows: any[]): any => {
  const sum = (key: string) => {
    const values = filter(map(rows, key), value => typeof value === 'number' && !isNaN(value));
    return values.length > 0 ? sumBy(values, v => v) : undefined;
  };

  return {
    _id: RowType.Total,
    [TaxAnalysisTableKeys.Ticker]: formatMessage('Comparison.TaxAnalysis.TotalRowTicker'),
    [TaxAnalysisTableKeys.Name]: '',
    [TaxAnalysisTableKeys.Units]: undefined,
    [TaxAnalysisTableKeys.CostBasis]: undefined,
    [TaxAnalysisTableKeys.MarketValue]: sum(TaxAnalysisTableKeys.MarketValue),
    [TaxAnalysisTableKeys.ShortTermUnrealizedGainLoss]: sum(TaxAnalysisTableKeys.ShortTermUnrealizedGainLoss),
    [TaxAnalysisTableKeys.LongTermUnrealizedGainLoss]: sum(TaxAnalysisTableKeys.LongTermUnrealizedGainLoss),
    [TaxAnalysisTableKeys.TotalUnrealizedGainsLoss]: sum(TaxAnalysisTableKeys.TotalUnrealizedGainsLoss),
    [TaxAnalysisTableKeys.CurrentAllocation]: sum(TaxAnalysisTableKeys.CurrentAllocation),
    [TaxAnalysisTableKeys.ValueChange]: sum(TaxAnalysisTableKeys.ValueChange),
    [TaxAnalysisTableKeys.EstimatedRealizedGainLoss]: sum(TaxAnalysisTableKeys.EstimatedRealizedGainLoss),
    [TaxAnalysisTableKeys.TaxCostToReachTarget]: sum(TaxAnalysisTableKeys.TaxCostToReachTarget),
  };
};
